<section class="dropdown language-selector">
  <button class="btn dropdown-toggle" type="button" id="languageOptions" data-bs-toggle="dropdown" aria-expanded="false">
    <img class="language-selector__img language-selector__img--reduced" src="resources/img/icons/traduccion.png" alt="Language icon" />
  </button>
  <ul class="dropdown-menu" aria-labelledby="languageOptions">
    <li>
      <button class="dropdown-item" (click)="onLanguageSelect('en')">{{ 'shared.header.languages.en' | translate }}</button>
    </li>
    <li>
      <button class="dropdown-item" (click)="onLanguageSelect('es')">{{ 'shared.header.languages.es' | translate }}</button>
    </li>
    <li>
      <button class="dropdown-item" (click)="onLanguageSelect('pt')">{{ 'shared.header.languages.pt' | translate }}</button>
    </li>
  </ul>
</section>
